function ponte() {
  try {
    return window.chrome && window.chrome.webview && window.chrome.webview.postMessage ? window.chrome.webview : null;
  } catch (e) {
    return null;
  }
}

export default {
  disponivel() {
    return !!ponte();
  },
  enviar(mensagem) {
    const webview = ponte();
    if (!webview) return false;

    webview.postMessage(JSON.stringify(mensagem));
    return true;
  },
  fechar() {
    return this.enviar({ acao: 'fechar' });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/js/desktop-embed.js